import React from 'react';
import { Box, Chip, Theme, Tooltip } from '@mui/material';
import { ColumnImportData } from '../parse';
import { makeStyles } from '@mui/styles';

interface Props {
	importData: ColumnImportData['invalid'];
}

const InvalidColumns = (props: Props) => {
	const classes = useStyles();
	return (
		<Box mt={2} ml={2.5}>
			{Object.entries(props.importData).map(([name, error], i) => {
				return (
					<Tooltip title={error} key={name + i} classes={{ tooltip: classes.tooltip }}>
						<Chip sx={{ m: 0.5 }} label={name} variant="outlined" color="error" />
					</Tooltip>
				);
			})}
		</Box>
	);
};

const useStyles = makeStyles((theme: Theme) => ({
	tooltip: {
		backgroundColor: theme.palette.common.black,
		color: theme.palette.common.white,
	},
}));

export default InvalidColumns;
